// 1
import gql from 'graphql-tag'

// 2

// Seiten-Assets und Homepage
export const WELCOME = gql`
  query Welcome {
    language(name: "german")
    welcome(s: "has_parent=/website/global-spenden/") {
      list {
        id
        title
        image {
          variations {
            httpUrl
            width
            height
            description
          }
        }
        headline
        subheadline_one
        subheadline_two
        button_text_one
      }
    }
  }
`
export const INTRODUCTION = gql`
  query Introduction {
    language(name: "german")
    introduction_donations(s: "has_parent=/website/home-spenden/") {
      list {
        id
        title
        body_text
        body_text_2
        button_text_one
        button_text_two
        button_text_three
        button_text_four
        pdf_file {
          description
          httpUrl
        }
      }
    }
  }
`
export const EXPLANATION = gql`
  query Explanation($selector: Selector) {
    language(name: "german")
    repeater_explanation_slideshow(s: $selector) {
      getTotal
      list {
        id
        image {
          description
          variations {
            httpUrl
            width
            height
          }
        }
        headline
        body_text
        button_text_one
        button_link_one
      }
    }
  }
`
export const CALL_TO_ACTION = gql`
  query CallToAction($parentPath: Selector) {
    language(name: "german")
    call_to_action(s: $parentPath) {
      list {
        id
        headline
        body_text
        button_text_one
        button_text_two
        gallery {
          variations {
            description
            httpUrl
            width
            height
          }
        }
      }
    }
  }
`
export const FOOTER = gql`
  query Footer {
    language(name: "german")
    footer {
      list {
        id
        name
        title
        headline
        body_text
        name_text
        street
        postal_code
        city
        phone_number
        fax_number
        email
      }
    }
  }
`
/**
 * parent.name=for-page-xyz
 *
 * WTF ?!
 *
 * das ist eine Eigenheit der GraphQL Erweiterung für Processwire, es muss die
 * Daten direkt aus dem Repeater ziehen und kann nicht direkt über die Seite auf
 * den Repeater nach unten gehen.
 *
 * Daher ggf. bei Änderungen im PW-Backend nachschauen unter der Repeater-Page
 * Admin > Repeaters > sponsors_organization > footer
 * Unter Bearbeiten > Einstellungen den Namen nachsehen
 */
export const FOOTER_SPONSORS = gql`
  query FooterSponsors {
    language(name: "german")
    repeater_sponsors_organization(s: "parent.name=for-page-2467") {
      list {
        id
        image {
          httpUrl
          width
          height
          description
          ext
        }
        title
        http_url
      }
    }
  }
`
// Orgel
export const PRICE_QUERY = gql`
  query Price {
    language(name: "german")
    price {
      list {
        id
        title
        amount
        body_text
      }
    }
  }
`
export const ORGAN_QUERY = gql`
  query Organ {
    language(name:"german")
    pipe_organ {
      list {
        id
        title
      }
    }
  }
`
export const WORKS_QUERY = gql`
  query Works {
    language(name:"german")
    organ_work {
      list {
        parentID
        id
        title
      }
    }
  }
`
export const STOPS_QUERY = gql`
  query Stops {
    language(name:"german")
    organ_stop(s: "sort=sort") {
      list {
        numChildren
        parentID
        id
        title
        length
        remark
      }
    }
  }
`
export const STOPS_QUERY_SEARCH = gql`
  query Stops($hasPrice: Selector) {
    language(name:"german")
    organ_stop(s: "numChildren>0") {
      list {
        numChildren
        children(s: $hasPrice) {
          getTotal
        }
        parentID
        id
        title
        length
        remark
      }
    }
  }
`
export const PIPES_MATCH_STOPS = gql`
  query PipesMatchStops($selector: Selector!) {
    language(name: "german")
    pipe(s: $selector) {
      list {
        id
        parentID
      }
    }
  }
`
export const PIPES_SEARCH_QUERY = gql`
  query Pipes($selector: Selector!) {
    language(name:"german")
    pipe(s: $selector) {
      list {
        parentID
        id
        title
        tone_ref {
          list {
            id
            name
            title
            index
          }
        }
        price_ref {
          list {
            title
            amount
          }
        }
        sponsor_ref {
          list {
            id
          }
        }
      }
    }
  }
`
export const TONE_QUERY = gql`
  query Tone {
    language(name:"german")
    tone {
      list {
        id
        title
      }
    }
  }
`
export const FIND_SPONSOR = gql`
  query FindSponsor($selector: Selector) {
    sponsor(s: $selector) {
      list {
        id
      }
    }
  }
`

// Mutations
export const CREATE_SPONSOR_MUTATION = gql`
  mutation CreateSponsor($parent: String!, $name: String!, $title: String!, $email_unique: String!, $allow_publication: Boolean, $street: String!, $postal_code: String!, $city: String!) {
    createSponsor(page: {
      parent: $parent,
      name: $name,
      title: $title,
      email_unique: $email_unique,
      allow_publication: $allow_publication,
      street: $street,
      postal_code: $postal_code,
      city: $city
    }) {
      id
    }
  }
`
export const CREATE_SPONSORSHIP_ORDER = gql`
  mutation CreateSponsorshipOrder($parent: String!, $name: String!, $title: String!, $sponsor_ref: [Int], $pipes_ref: [Int], $name_text: String) {
    createSponsorship_order(page: {
      parent: $parent,
      name: $name,
      title: $title,
      sponsor_ref: $sponsor_ref,
      pipes_ref: $pipes_ref,
      name_text: $name_text
    }) {
      id
    }
  }
`
export const PIPE_ADD_SPONSOR = gql`
  mutation AddSponsorToPipe($id: Int!, $sponsor_ref: [Int]) {
    updatePipe(id: $id, page: {
      sponsor_ref: $sponsor_ref
    }) {
      id
    }
  }
`
export const TOTAL_PIPES = gql`
  query TotalPipes {
    pipe {
      getTotal
    }
  }
`
export const TAKEN_PIPES = gql`
  query TakenPipes {
    pipe(s: "sponsor_ref!=0"){
      getTotal
      list {
        price_ref {
          list {
            amount
          }
        }
      }
    }
  }
`
export const GET_PIPE_BY_PRICE = gql`
  query GetPipeByPrice($amount: String!) {
    pipe(s: "price_ref.amount=$amount") {
      getTotal
    }
  }
`
export const SPONSORSHIP_LIST = gql`
  query SponsorshipList {
    language(name: "german")
    repeater_sponsor_list_repeater {
      list {
        id
        body_text
      }
    }
  }
`
export const IMPRINT = gql`
  query Imprint {
    language(name: "german")
    imprint {
      list {
        title
        body_text
      }
    }
  }
`
export const PRIVACY_POLICY = gql`
  query PrivacyPolicy {
    language(name: "german")
    privacy_policy {
      list {
        title
        body_text
      }
    }
  }
`
export const CONFIGURATOR = gql`
  query Configurator {
    language(name: "german")
    configurator {
      list {
        title
        body_text
      }
    }
  }
`
export const DONATION = gql`
  query Donation {
    language(name: "german")
    donation {
      list {
        title
        body_text
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/constants/graphql.js